const environmentVariables = {
  apiIdentifier: process.env.REACT_APP_AUTH0_AUDIENCE,
  apiUrl: process.env.REACT_APP_API_SERVER_URL,
  authDomain: process.env.REACT_APP_AUTH0_DOMAIN,
  authClientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  authCallbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL,
  logoutReturnUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL
};

export default environmentVariables;